/**
 * Single source of runtime configuration. Reads from window.__ADMIN_ENV__ (set
 * by docker/entrypoint.sh at container start) first, then falls back to
 * import.meta.env (dev / static builds). Never read import.meta.env elsewhere.
 */

function runtime(): AdminRuntimeEnv {
  return (typeof window !== 'undefined' && window.__ADMIN_ENV__) || {};
}

function str(runtimeKey: keyof AdminRuntimeEnv, buildValue: string | undefined, fallback = ''): string {
  const r = runtime()[runtimeKey];
  if (r !== undefined && r !== '') return r as string;
  if (buildValue !== undefined && buildValue !== '') return buildValue;
  return fallback;
}

function num(value: string, fallback: number): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export const env = {
  /** Base URL of the API. '' means same-origin (proxy). */
  apiBaseUrl: str('API_BASE_URL', import.meta.env.VITE_ADMIN_API_BASE_URL),
  siteUrl: str('SITE_URL', import.meta.env.VITE_ADMIN_SITE_URL, 'http://localhost:5174'),
  appUrl: str('APP_URL', import.meta.env.VITE_ADMIN_APP_URL, 'http://localhost:5173'),
  idleTimeoutMin: num(str('IDLE_TIMEOUT_MIN', import.meta.env.VITE_ADMIN_IDLE_TIMEOUT_MIN, '30'), 30),
  stepUpWindowMin: num(
    str('STEPUP_WINDOW_MIN', import.meta.env.VITE_ADMIN_STEPUP_WINDOW_MIN, '10'),
    10,
  ),
  sentryDsn: str('SENTRY_DSN', import.meta.env.VITE_ADMIN_SENTRY_DSN),
  isDev: import.meta.env.DEV,
} as const;
